<template>
  <div class="coupon-setting-qr-only q-pa-md">
    <q-checkbox
      v-model="form.SHOW_QR_CODE"
      true-value="1"
      false-value="0"
      label="在券详情中展示二维码"
      @update:model-value="onShowQrCodeChange"
      size="sm"
    />
    <div class="row justify-end q-mt-lg">
      <q-btn color="primary" label="提交" @click="handleSubmit" :loading="submitting" />
    </div>
  </div>
</template>

<script>
import Config from "rsui-core/src/config";
export default {
  name: "CouponSettingQrOnly",
  props: {
    defValue: {
      type: Object,
      default: () => ({}),
    },
    settingId: {
      type: [Number, String],
      default: "",
    },
    tenantId: {
      type: Number,
      default: null,
    },
    closeDialog: {
      type: Function,
    },
    refresh: {
      type: Function,
    },
    isSpecType: {
      type: Boolean,
    },
    isCouponMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      submitting: false,
      form: {
        SHOW_QR_CODE: "1",
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const config = this.defValue?.ext?.CONFIG;
      this.form.SHOW_QR_CODE =
        config && config.SHOW_QR_CODE !== undefined && config.SHOW_QR_CODE !== null ? String(config.SHOW_QR_CODE) : "1";
    },
    onShowQrCodeChange() {},
    async handleSubmit() {
      this.submitting = true;
      try {
        const prevConfig = this.defValue?.ext?.CONFIG || {};
        const submitData = {
          ...prevConfig,
          SHOW_QR_CODE: this.form.SHOW_QR_CODE,
        };
        const postParams = {
          ...this.defValue,
          setting: { id: this.settingId },
          tenant: { id: this.tenantId },
          ext: {
            ...(this.defValue.ext || {}),
            CONFIG: submitData,
          },
        };
        if ((this.isSpecType || this.isCouponMode) && this.defValue.sysReserved) {
          postParams.id = null;
        }
        await this.$rs_post(Config.API.TEN_MODULE_SETTING_DETAIL_CREATE_OR_UPDATE, postParams);
        this.$q.notify({
          type: "positive",
          message: "提交成功！",
          position: "top",
        });
        this.closeDialog();
        this.refresh();
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.coupon-setting-qr-only {
  min-width: 320px;
}
</style>
